import { Component, Input, OnInit } from '@angular/core'
import { Image, MediaInterface, Sources } from '../../../interfaces'

@Component({
  selector: 'dmmp-image',
  templateUrl: './image.component.html',
})
export class ImageComponent implements OnInit {
  @Input() images: Image
  @Input() medias: MediaInterface[]
  @Input() defaultClass: string
  sources: Sources = { seo: { title: '', alt: '' }, images: [] }

  ngOnInit() {
    this.medias?.forEach((item) => {
      this.sources?.images?.push({
        url: this.images?.styles[item.style],
        media: item?.media,
      })
    })
    this.sources.seo = {
      title: this.images?.texts?.title,
      alt: this.images?.texts?.alt,
    }
  }
}
